import useSWR from 'swr'
import { z } from 'zod'

import { tolerantTaskSchema } from '../types'
import { validateResponse } from '../utils'
import { useTalentApi } from '../store/mainContext'

interface DoneTasksFilters {
  from: number
  to: number
  userId?: string
}

export default function useDoneTasks({ from, to, userId }: DoneTasksFilters) {
  const api = useTalentApi()

  const shouldFetch = Number.isFinite(from) && Number.isFinite(to) && from <= to

  return useSWR(shouldFetch ? ['tasks-done', from, to, userId] : null, () => {
    const params: Record<string, unknown> = {
      isDone: true,
      doneOn: { $gte: from, $lte: to },
    }

    if (userId) {
      params.doneBy = userId
    }

    return api
      .get('tasks/pro', {
        params,
        headers: {
          'astor-sortby': 'doneOn',
          'astor-sortby-dir': '-1',
        },
      })
      .then(validateResponse(z.array(tolerantTaskSchema)))
  })
}
